import { NotificationsBell } from "../notifications/NotificationsBell";

/** GAVION: mount slot for the notifications bell (spec 05 §8, boss ruling: never in the upstream Header). */
export const NotificationsBellSlot = () => <NotificationsBell />;
